export default __webpack_public_path__ + "img/b502b33992ac8b9fbc0cbf49e3333122.png";